import { render } from "./userAccounts.vue?vue&type=template&id=779b2c72"
import script from "./userAccounts.vue?vue&type=script&lang=js"
export * from "./userAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__